import { Component, Input } from '@angular/core';
import { AddComment } from './state/comments.actions';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
  standalone: false,
})
export class CommentsComponent {
  @Input() entityId: string;
  @Input() entityType: number;
  @Input() privilege: string;
  @Input() canAddComment = true;
  @Input() isInPopup = false;
  @Input() adminPrivilege: string;
  @Input() showDeleteButton = true;

  loadingActions = [AddComment];
}
